import { tuple } from '../../utils/types';
import onchainidSVG from './assets/onchainid.svg';
import metamaskSVG from './assets/metamask.svg';
import BTCSVG from './assets/BTC.svg';
import ETHSVG from './assets/ETH.svg';
import USDTSVG from './assets/USDT.svg';
import USDCSVG from './assets/USDC.svg';
import ethereumSVG from './assets/ethereum.svg';
import polygonSVG from './assets/polygon.svg';
import sandboxSVG from './assets/sandbox.svg';
import avalancheSVG from './assets/avalanche.svg';
import klaytnSVG from './assets/klaytn.svg';
import telosSVG from './assets/telos.svg';
import EUReSVG from './assets/EURe.svg';
import baseSVG from './assets/base.svg';
export const logoAssets = {
  'onchainid': onchainidSVG,
  'metamask': metamaskSVG,
  'ethereum': ethereumSVG,
  'polygon': polygonSVG,
  'sandbox': sandboxSVG,
  'avalanche': avalancheSVG,
  'klaytn': klaytnSVG,
  'telos': telosSVG,
  'BTC': BTCSVG,
  'ETH': ETHSVG,
  'USDT': USDTSVG,
  'USDC': USDCSVG,
  'MATIC': polygonSVG,
  'EURe': EUReSVG,
  'base': baseSVG
};
export const logoNames = tuple(...Object.keys(logoAssets));
